import * as React from 'react';
import { connect } from 'react-redux';

import { IStore } from 'src/services/store';
import API from 'src/services/api';
import { simplePage } from './simplePage';
import { Button } from 'src/components';

const navigatorLang =
  window.navigator.language.slice(0, 2) === 'de' ? 'de' : 'en';

const DataProtection = ({ showDe = false }) => {
  const [lang, setLang] = React.useState(showDe ? navigatorLang : 'en');
  const toggleLang = () => {
    setLang(lang === 'de' ? 'en' : 'de');
  };
  const SimplePage = simplePage(
    lang === 'de'
      ? API.CONTENT.dataProtection()
      : API.CONTENT.dataProtectionEn()
  );

  return (
    <>
      {showDe && (
        <div className="max-w-md mx-auto mt-16 mb-8">
          <Button size="small" onClick={toggleLang}>
            {lang === 'de' ? 'English' : 'Deutsch'}
          </Button>
        </div>
      )}
      <SimplePage forceReload={lang} margins="mb-24" />
    </>
  );
};

const mapStateToProps = (state: IStore) => ({
  showDe: state.settings.showDataProtectionDe,
});

export default connect(mapStateToProps)(DataProtection);



// WEBPACK FOOTER //
// ./src/views/DataProtection.tsx